import Vue from "vue";
import router from "@/router/index.js";
import axios from "axios";
import VueAxios from "vue-axios";
import { base_url } from "../http.js";

let axiosInstance = axios.create({
    baseURL: base_url,
});
//
//
// // Предварительная обработка запросов
// axiosInstance.interceptors.request.use(function (config) {
//   let config_ = config;
//   // const token = localStorage.getItem('token');
//   const access_token = localStorage.getItem('access_token');
//   if (access_token) {
//     config_.headers.Authorization = 'Token ' + token;
//     if (this.$route.name !== "login") {
//       config_.headers.Authorization = 'Bearer ' + access_token;
//     }
//     console.log(this);
//   }
//   return config_;
// }, function (error) {
//   // Do something with request error
//   return Promise.reject(error);
// });
//
//
// Предварительная обработка ответов
// axiosInstance.interceptors.response.use(null, function(error) {
//   if (error.response.status === 401 || error.response.status === 403) {
//     // localStorage.removeItem('access_token');
//     // router.push('/login');
//     console.log(54545454545454545454545454);
//     this.$store.dispatch("refreshTokens").catch(() => {
//       router.push("/login");
//     });
//
//     // Vue.prototype.$Message.error('Пользователь не аутентифицирован');
//   }
//   // else if (error.response.status === 403) {
//   //   Vue.prototype.$Message.error('Доступ запрещен');
//   // }
//   return Promise.reject(error);
// });

export default axiosInstance;



// WEBPACK FOOTER //
// ./src/api/axios.js